import { NetworkErrorService } from "./NetworkError.service";
import { OauthService } from "./oauth.service";
import { UserStore } from "./stores/UserStore";
import { LoginService } from "@app/services/Login.service";
import { take } from "rxjs/operators";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";

/**
 * Created by req85103 on 7/14/17.
 */
export interface IMobileLoginService {
    login(): Observable<any> ;
}
@Injectable()
export class MobileLoginService {

    constructor(@Inject(OauthService) private OauthService: OauthService,
                @Inject(UserStore) private userStore: UserStore,
                @Inject(NetworkErrorService) private NetworkErrorService: NetworkErrorService,
                @Inject(LoginService) private loginService: LoginService) {

    }

    login(): Observable<any> {
        return new Observable<any>((subscriber) => {
            this.OauthService.authenticate().pipe(take(1)).subscribe((success) => {
                // this.AmuiService.authenticate().then((success) =>{
                sessionStorage.setItem('hoapay_initialLogin', "false");
                sessionStorage.setItem('hoapay_accessToken', success.access_token);
                this.OauthService.getUser().pipe(take(1)).subscribe(resp => {
                    this.userStore.setClientId(resp.clientid);
                    this.userStore.setEmail(resp.email);
                    this.userStore.setFirstName(resp.firstname);
                    this.userStore.setLastName(resp.lastname);
                    this.userStore.setName(resp.name);
                    //use the hoahomeowner unless using an internal account, which we will then use the hard coded 7 id until internal is completely removed
                    this.userStore.setHoaHomeownerId(resp.hoahomeowner ? parseInt(resp.hoahomeowner) : 7);
                    this.userStore.setSsoOrigin(resp.ssoorigin ? resp.ssoorigin : '');

                    this.OauthService.setFreshLogin(false);
                    this.loginService.login();
                    subscriber.next(undefined);
                });
            }, (err) => {
                if (err !== 'user pressed done') {
                    this.NetworkErrorService.handleNetworkError(err, true).pipe(take(1)).subscribe((shouldRetry) => {
                        subscriber.error();
                        if (shouldRetry === true) {
                            this.login();
                        }
                    });
                } else {
                    subscriber.error();
                }
            });
        });
    }
}

